import { MultiProviderConfig, ShopType, CheckoutType } from 'types';
import { ProviderConfigList } from 'config/providers';
import { UpdaterTheme } from 'config/themes';
import { allLeadMode } from 'config';

export const AppFolio: MultiProviderConfig = {
  name: 'AppFolio',
  micrositeCode: 'AppFolio',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: 'https://partner-cart.updater.com/provider/',
  title: 'Updater Internet Shopping for AppFolio Residents',
  fallbackPhoneNumber: '888-970-0053',
  fallbackLeadModePhoneNumber: '833-288-4510',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: UpdaterTheme,
  needsDcSession: false,
  updaterCrossSellActive: true,
  source: 'AppFolio',
  noOffersRetry: 2,
  // For now, we do not include Earthlink or TDS on AppFolio
  // https://updater.atlassian.net/browse/TVI-245
  providers: ProviderConfigList.filter(
    (provider) =>
      provider.providerCode !== 'earthlink' && provider.providerCode !== 'tds'
  ),
  getCheckoutType: allLeadMode,
  gtmCode: 'GTM-W5S4DCN4',
  suppressNormalizedAddressCheck: true,
  // https://updater.atlassian.net/jira/software/c/projects/TVI/boards/439?assignee=60bbd7523aa6050068a5fca0&selectedIssue=TVI-237
};
